import Vue from 'vue'

export default class PermissaoService {

    constructor() {
        //this._resource = resource('usuarios/permissoes');
    }

    buscarPermissoes() {
        return Vue.http.get('usuarios/permissoes')
            .then(res => res.json(), err => {
                throw new Error('Não foi possível obter as permissões');
            });
    }
    
}



// WEBPACK FOOTER //
// ./src/domain/permissao/PermissaoService.js